<div class="confirmation-dialog-container">
  <wcg-dialog
    [title]="data.title"
    [description]="data.message"
    [size]="data.dialogSize"
    data-testid="wcg-dialog"
  >
    <div secondary data-testid="secondary-button-container">
      <button
        color="primary"
        mat-button
        class="mdc-cancel-button"
        [mat-dialog-close]="false"
        data-testid="cancel-button"
      >
        {{ data.cancelButtonTitle ? data.cancelButtonTitle : "Cancel" }}
      </button>
    </div>
    <div primary>
      <button
        wcg-button
        mat-flat-button
        color="primary"
        [ngStyle]="{ 'background-color': data.buttonColor }"
        data-testid="confirm-button"
        (click)="onConfirmClick()"
      >
        {{ data.buttonTitle ? data.buttonTitle : "OK" }}
      </button>
    </div>
    @if (
      data.documents?.length ||
      data.requiredReason ||
      data.additionalDescription
    ) {
      <div content>
        <div class="doc-list-container">
          <ul class="doc-list">
            @for (doc of data.documents; track doc; let i = $index) {
              <li>
                <span>{{ doc }}</span>
              </li>
            }
          </ul>
        </div>
        @if (data.requiredReason) {
          <div>
            <form [formGroup]="reasonForm">
              <div class="w-full">
                <wcg-text-field-area
                  class="w-full"
                  [label]="data.reasonLabel ?? 'Reason'"
                  [errorText]="'Reason is required'"
                  height="comfortable"
                  [width]="'x-large'"
                  [isRequired]="true"
                  [formControl]="reasonForm.controls['reason']!"
                />
              </div>
            </form>
          </div>
        }

        @if (data.additionalDescription) {
          <div class="additionalDescription">
            <p [innerHTML]="data.additionalDescription"></p>
          </div>
        }
      </div>
    }
  </wcg-dialog>
</div>
